import { render } from "./HeaderDefault.vue?vue&type=template&id=74edece4&scoped=true"
import script from "./HeaderDefault.vue?vue&type=script&lang=js"
export * from "./HeaderDefault.vue?vue&type=script&lang=js"

import "./HeaderDefault.vue?vue&type=style&index=0&id=74edece4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74edece4"]])

export default __exports__